<template>
  <Form
    :title="title"
    :description="description"
    :handlePrevious="decrementIndex"
    :handleNext="incrementIndex"
    :isDisabled="!stack || !language"
  >
    <SelectField
      label="Stack"
      :options="['Front', 'Back', 'FullStack']"
      :value="stack"
      isRequired
      @input="$event => setStack($event.target.value)"
    />
    <SelectField
      label="Language"
      :options="['JavaScript', 'Python', 'Java', 'PHP', 'Other']"
      :value="language"
      isRequired
      @input="$event => setLanguage($event.target.value)"
    />
    <InputField
      label="Other"
      placeholder="Go, Rust..."
      :value="other"
      @input="$event => setOther($event.target.value)"
    />
  </Form>
</template>

<script>
import Form from '@/components/Form';
import SelectField from '@/components/SelectField';
import InputField from '@/components/InputField';
import useIndex from '@/composition/useIndex';
import useField from '@/composition/useField';

export default {
  name: 'ProForm',
  components: {
    Form,
    SelectField,
    InputField
  },
  props: {
    title: String,
    description: String
  },
  setup() {
    const { incrementIndex, decrementIndex } = useIndex();
    const [stack, setStack] = useField('stack');
    const [language, setLanguage] = useField('language');
    const [other, setOther] = useField('other');

    return {
      incrementIndex,
      decrementIndex,
      stack,
      setStack,
      language,
      setLanguage,
      other,
      setOther
    };
  }
};
</script>
